// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import "@/assets/iconfont.css"
import '@/assets/icon/iconfont.css'
import '@/assets/styles/main.scss'
import '@/assets/styles/comom.scss'
// import '@/assets/icon.bk/iconfont.css'

import dateFormat from './common/date.js'
import option from './common/options.json'
import storage from './common/storage.js'
import utils from './common/util.js'
import configs from './configs/configs.js'
import request from './models/request.js'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment-timezone'
import VueAMap from 'vue-amap'; // 高德地图

import '../static/Ueditor/ueditor.config.js'
import '../static/Ueditor/ueditor.all.js'
import '../static/Ueditor/lang/zh-cn/zh-cn.js'
import '../static/Ueditor/ueditor.parse.min.js'

Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(VueAMap)

Vue.prototype.$http = request
Vue.prototype.$utils = utils
Vue.prototype.$dateFormat = dateFormat
Vue.prototype.$moment = moment
Vue.prototype.$option = option

VueAMap.initAMapApiLoader({
    key: '51f0458afe2c1bd45a9a5d3652ee31ab',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
    v: '1.4.15',
    uiVersion: '1.0.11'
});

// Vue.prototype.$moment.tz.setDefault('America/Los_Angeles')
// Vue.prototype.$moment.tz.setDefault('Asia/Shanghai')

Vue.mixin({
    data() {
        // 全局变量
        return {
            uploadUrl: configs.baseURL + '/common/upload/files',
            pageParamKey: ['loading', 'pageSize', 'total', 'currentPage', 'tableData'],
            serviceAddTypeCollection: "'22', '23', '24'"
        }
    },
    computed: {
        header() {
            let token = storage.getToken() || ''
            return {
                Authorization: "bearer " + token,
                // Accept: "application/vnd.caesar.v1+json",
            };
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            let token = storage.getToken() || ''
            if (!token) {
                /*vm.$message({
                    showClose: true,
                    message: "登录已过期，请重新登录",
                    type: "warning"
                });*/
                setTimeout(() => {
                    vm.$router.push({
                        path: '/login'
                    })
                }, 1000)
            }
        })
    },
    methods: {
        open(url) {
            window.open(url)
        }
    }
})
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
})
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js